







































































import { Component, Vue, Watch } from "vue-property-decorator";
import * as util from "@/util";
import { User, Company, VueRoot, Branch, Terminal, ManualCloseRequest } from "@/domain";
import PayCardForm from "@/components/payment/PayCardForm.vue";
import MoneyField2 from "@/components/MoneyField2.vue";
import { domain } from "@/domain";
import * as uiUtil from "@/uiUtil";

@Component({ components: { PayCardForm, MoneyField2 } })
export default class ManualCloseDialog extends Vue {
  // New/Edit dialog
  dialog = false;
  disablePayment = true;
  savingData = false;
  branches: Branch[] = new Array<Branch>();
  companyId: null | number = null;
  branchID: null | number = null;
  selectedBranch: null | Branch = null;
  selectedTerminal: null | Terminal = null;

  @Watch("selectedBranch")
  changeBranch() {
    this.selectedTerminal = null;
  }

  get terminals() {
    if (!this.selectedBranch) return [];
    return this.selectedBranch.terminals;
  }

  get lang() {
    return this.$store.state.lang.data;
  }

  get currentUser(): User {
    return this.$store.state.currentUser || {};
  }

  get currentCompany(): Company | null {
    if (this.$store.state.selectedCompanyLoading) {
      return null;
    }
    return this.$store.state.selectedCompany;
  }

  get isMobile(): boolean {
    return (this.$root as VueRoot).isMobile;
  }

  snackShow(message: string, color: string) {
    this.$emit("message", { message, color });
  }

  get disableProcessBtn() {
    if (!this.selectedBranch) return true;
    if (this.savingData) return true;
    return false;
  }

  async cmdProcess(type: "closeBranch" | "closeTerminal") {
    if (this.disableProcessBtn || !this.companyId || !this.selectedBranch || !this.selectedBranch.terminals || !type)
      return this.snackShow(this.lang.errorCheckForm, "error");
    this.savingData = true;
    const request: ManualCloseRequest = {
      companyID: this.companyId,
      branchID: util.toNumber(this.selectedBranch.id),
      tcod: this.selectedTerminal?.tcod ?? this.selectedBranch.terminals[0].tcod,
      terminalID: this.selectedTerminal?.code
        ? util.toNumber(this.selectedTerminal?.code)
        : util.toNumber(this.selectedBranch.terminals[0].code),
      action: type
    };
    try {
      const response = await domain.backend.executeManualClose(request);
      this.snackShow(response.result, "success");
      this.savingData = false;
    } catch (error) {
      util.logError("Error ejecutar la transacción", error);
      this.savingData = false;
      this.snackShow(uiUtil.toErrorMsg(error, this.lang.errorCouldNotExecuteTransaction), "error");
    }
  }

  close() {
    this.dialog = false;
  }

  open(branches: Branch[], companyId: number, selBranchID: number | null, selTerminalTcod: string | null) {
    const filteredBranches = JSON.parse(JSON.stringify(branches)).filter(
      (b: Branch) => b.manualClose === true && b.id !== -1
    );
    this.branches = filteredBranches;
    this.companyId = companyId;
    const selectedBranch = this.branches.find((b) => b.id === selBranchID);
    if (selectedBranch) {
      this.selectedBranch = selectedBranch;
      setTimeout(() => {
        if (this.selectedBranch?.terminals && selTerminalTcod) {
          const selectedTerminal = this.selectedBranch.terminals.find((t) => t.tcod === selTerminalTcod);
          if (selectedTerminal) this.selectedTerminal = selectedTerminal;
        }
      }, 200);
    }
    this.dialog = true;
  }

  @Watch("dialog")
  clearData() {
    if (this.dialog === false) {
      // CLEAR INFORMATION
      this.companyId = null;
      this.selectedBranch = null;
      this.selectedTerminal = null;
    }
  }
}
